<template>
  <div class="info-alert text-nowrap text">
    <mdicon name="InformationOutline" />
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'InfoAlert',
})
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables' as vars;
.info-alert {
  display: flex;
  align-items: center;
  padding: 8px 12px 8px 12px;
  line-height: 21px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 2px;
  svg {
    width: 21px;
  }
  span {
    margin-right: 8px;
  }
  &.danger {
    background: rgba(vars.$danger, 0.1);
    color: vars.$orange;
  }

  &.success {
    background: rgba(vars.$green, 0.1);
    color: vars.$green;
  }

  &.secondary {
    background: vars.$light-gray-bg;
    color: vars.$black;
  }
}
</style>
